import { User } from "../types/auth";

export const hasModulePermission = (
  user: User | null,
  moduleName: string,
  action: "read" | "write" | "update" | "upload" | "delete" = "read"
): boolean => {
  if (!user?.role?.permissions) return false;

  const module = user.role.permissions.find(
    (p) => p.module_name.toLowerCase() === moduleName.toLowerCase()
  );

  return module?.permissions?.[action] === true;
};
